module.exports = __webpack_public_path__ + "static/analytics-sku-level@2x-51dc2d06d86d76dc6f9101b8e0dd22e7.png";